module.exports = __webpack_public_path__ + "img/screen_logo_1.72daea58.png";